import { Button } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import { addLocalResponsable, deleteLocalResponsable } from "../../../../redux/actions/rgrl";
import ConfirmDialog from "../../../commons/dialog/ConfirmDialog";
import FechaPresentacionLabel from "../../../commons/planillas/FechaPresentacionLabel";
import ResponsablesContainer from "../../../commons/responsables/ResponsablesContainer";
import { StyledRgrl } from "../../../styled/Prevencion";

const ResponsablesContainerRGRL = ({ nextForm, handleCancel }) => {
  const listaResponsables = useSelector((state) => state.rgrl.postRgrl.responsables)
  const [openCancel, setOpenCancel] = useState();
  const handleSubmit = () => {
    nextForm("Presentación")
  }
  return (
    <>
      <FechaPresentacionLabel />
      <ResponsablesContainer
        handleSubmit={handleSubmit}
        listaResponsables={listaResponsables}
        addLocalResponsable={addLocalResponsable}
        deleteLocalResponsable={deleteLocalResponsable}
      />
      <StyledRgrl.ButtonContainer style={{ marginTop: "20px" }}>
        <Button color="secondary" onClick={() => setOpenCancel(true)}>
          Cancelar
        </Button>
        <Button variant="contained" color="primary" onClick={handleSubmit} disabled={listaResponsables.length <= 0}>
          Siguiente
        </Button>
      </StyledRgrl.ButtonContainer>
      <ConfirmDialog
        open={openCancel}
        handleClose={() => setOpenCancel(false)}
        handleConfirm={() => {
          setOpenCancel(true)
          handleCancel()
        }}
        title="Cancelar"
        text="¿Está seguro de que desea cancelar? Toda la carga realizada en el formulario no se guardará"
      />
    </>

  )
};

export default ResponsablesContainerRGRL;
